import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMeistarklaseCoupons, reset } from '../features/order/orderSlice';
import { useNavigate } from 'react-router-dom';
import Spinner from '../components/Spinner';

function Coupons() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { user } = useSelector((state) => state.auth);
    const { coupons, isLoading, isError, message } = useSelector(
        (state) => state.order
    ); 

    useEffect(() => {
        dispatch(getMeistarklaseCoupons());
    }, []);

    const clickUsedCoupon = (orderId) => {
        // navigate in new tab to /?orderId=orderId
        window.open(`/?orderId=${orderId}`, '_blank');
      };

    if(isLoading) {
        return <Spinner />
    }

    return (
        <div className='gift-card-management'>
            <h2 className="light padding-20-top">Kuponi</h2>
            <table>
                <thead>
                    <tr>
                        <th>Pasūtījuma ID</th>
                        <th>Klienta e-pasts</th>
                        <th>Kupona kods</th>
                        <th>Izmantots</th>
                    </tr>
                </thead>
                <tbody>
                    {coupons && coupons.map((coupon) => (
                        <tr key={coupon.id}>
                            <td>{coupon.order_id}</td>
                            <td>{coupon.client_email}</td>
                            <td>{coupon.coupon_code}</td>
                            <td>
                                {coupon.coupon_used.coupon_used ? (
                                    <span
                                    className="used-coupon"
                                    onClick={() => clickUsedCoupon(coupon.coupon_used.order.id)}
                                    >
                                    Jā ({coupon.coupon_used.order.id})
                                    </span>
                                ) : (
                                    "Nē"
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default Coupons